import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

export const formatAgentMessageTimestamp = (
  timestamp: number | null | undefined,
  locale: string
): string | null => {
  if (typeof timestamp !== 'number' || !Number.isFinite(timestamp)) return null;

  const date = new Date(timestamp * 1000);
  if (Number.isNaN(date.getTime())) return null;

  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  } catch {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }
};

type AgentMessageTimestampProps = {
  timestamp: number | null | undefined;
  label: string;
  isEstimated?: boolean;
  color?: string;
};

const AgentMessageTimestamp = ({
  timestamp,
  label,
  isEstimated = false,
  color
}: AgentMessageTimestampProps) => {
  const {i18n, t} = useTranslation();
  const date = typeof timestamp === 'number' ? new Date(timestamp * 1000) : null;
  const formattedTimestamp = formatAgentMessageTimestamp(
    timestamp,
    i18n?.resolvedLanguage || i18n?.language || 'ja'
  );

  if (!formattedTimestamp || !date || Number.isNaN(date.getTime())) return null;

  return (
    <Typography
      component="time"
      dateTime={date.toISOString()}
      variant="caption"
      color={color || 'text.secondary'}
      aria-label={`${label}${isEstimated ? ` (${t('推定')})` : ''} ${formattedTimestamp}`}
      title={isEstimated ? t('推定') : undefined}
    >
      {isEstimated ? `≈ ${formattedTimestamp}` : formattedTimestamp}
    </Typography>
  );
};

export default AgentMessageTimestamp;
